import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import portalAdminService from '../../services/portalAdminService';
import portalService from '../../services/portalService';
import PortalShell from './PortalShell';

export default function PortalAdminMembersPage() {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [city, setCity] = useState('');
  const [cities, setCities] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tierBusy, setTierBusy] = useState(null);

  const toggleTier = async (m, e) => {
    e.preventDefault();
    e.stopPropagation();
    const next = m.keyTier === 'key_holder' ? 'member' : 'key_holder';
    setTierBusy(m.userId);
    const r = await portalAdminService.setKeyTier(m.userId, next);
    setTierBusy(null);
    if (r.success) setRows((rs) => rs.map((x) => (x.userId === m.userId ? { ...x, keyTier: next } : x)));
  };

  useEffect(() => {
    portalService.listCities().then((r) => { if (r.success) setCities(r.data || []); });
  }, []);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(async () => {
      const r = await portalAdminService.listMembers({ search: search || undefined, city: city || undefined });
      if (r.success) setRows(r.data || []);
      setLoading(false);
    }, 250);
    return () => clearTimeout(t);
  }, [search, city]);

  return (
    <PortalShell viewerState="accepted">
      <div style={{ maxWidth: 1000, margin: '32px auto 80px', padding: '0 24px' }}>
        <button onClick={() => navigate('/noir/admin')} className="portal-mono" style={{ background: 'none', border: 'none', color: 'rgba(236,231,218,0.34)', cursor: 'pointer', fontSize: 11, marginBottom: 24 }}>← ADMIN</button>
        <p className="portal-label" style={{ marginBottom: 14 }}>MEMBERS</p>
        <h1 className="portal-hero" style={{ marginBottom: 24 }}>In the room<span className="portal-gold">.</span></h1>

        <div className="portal-grid-search" style={{ marginBottom: 18 }}>
          <input className="portal-input" placeholder="Search by name or @handle…" value={search} onChange={(e) => setSearch(e.target.value)} />
          <select className="portal-input" value={city} onChange={(e) => setCity(e.target.value)}>
            <option value="">All cities</option>
            {cities.map((c) => <option key={c.slug} value={c.slug}>{c.label}</option>)}
          </select>
        </div>

        <div className="portal-card" style={{ padding: 0 }}>
          {loading ? (
            <p className="portal-mono" style={{ color: 'rgba(236,231,218,0.34)', padding: 18, fontSize: 11 }}>LOADING…</p>
          ) : rows.length === 0 ? (
            <p className="portal-mono" style={{ color: 'rgba(236,231,218,0.34)', padding: 18, fontSize: 11 }}>NO MEMBERS YET.</p>
          ) : (
            rows.map((m) => {
              const role = (m.portalRole === 'owner' || m.portalRole === 'admin') ? m.portalRole.toUpperCase() : null;
              return (
                <div key={m.userId} style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 18px', borderBottom: '1px solid rgba(236,231,218,0.12)' }}>
                  <Link to={`/noir/admin/members/${m.userId}`} style={{ display: 'flex', alignItems: 'center', gap: 14, flex: 1, minWidth: 0, textDecoration: 'none' }}>
                    <div className="portal-avatar">
                      {m.avatarUrl ? <img src={m.avatarUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : null}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="portal-serif" style={{ fontSize: 18 }}>{m.displayName}</div>
                      <div className="portal-mono" style={{ fontSize: 10, color: 'rgba(236,231,218,0.34)' }}>
                        {m.handle ? `@${m.handle}` : ''}{m.location ? `${m.handle ? ' · ' : ''}${m.location.toUpperCase()}` : ''}{role ? `${m.handle || m.location ? ' · ' : ''}${role}` : ''}
                      </div>
                    </div>
                  </Link>
                  <button
                    type="button"
                    onClick={(e) => toggleTier(m, e)}
                    disabled={tierBusy === m.userId}
                    className={`portal-chip${m.keyTier === 'key_holder' ? ' active' : ''}`}
                    title={m.keyTier === 'key_holder' ? 'Unlimited keys — tap to set Member (5)' : '5 keys — tap to set Key Holder'}
                  >
                    {m.keyTier === 'key_holder' ? 'KEY HOLDER' : '5 KEYS'}
                  </button>
                </div>
              );
            })
          )}
        </div>
      </div>
    </PortalShell>
  );
}
